import React, { useState } from 'react';
import './ContactForm.css';

const EMPTY = { name: '', company: '', email: '', phone: '', subject: '', needs: '' };
const SUBJECTS = [
  'Site web / Landing page',
  'Application mobile',
  'E-commerce',
  'Maintenance / Support',
  'Autre',
];

export default function ContactForm() {
  const [form, setForm] = useState(EMPTY);
  const [submitting, setSubmitting] = useState(false);
  const [status, setStatus] = useState(null);
  const [errorMsg, setErrorMsg] = useState('');

  function handleChange(e) {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    if (status) setStatus(null);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!needsValid || !form.subject) return;
    setSubmitting(true);
    setStatus(null);
    try {
      const payload = {
        name: form.name.trim(),
        company: form.company.trim(),
        email: form.email.trim(),
        phone: form.phone.trim(),
        subject: form.subject,
        message: form.needs.trim(),
      };
      const base = process.env.REACT_APP_CONTACT_SERVICE || 'http://localhost:4500';
      const res = await fetch(base + '/messages', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(payload),
      });
      const json = await res.json().catch(() => null);
      if (!res.ok || (json && json.success === false)) {
        const msg = (json && json.error && json.error.message) || 'Erreur ' + res.status;
        throw new Error(msg);
      }
      setStatus('success');
      setForm(EMPTY);
    } catch (err) {
      setStatus('error');
      setErrorMsg(err.message || 'Erreur inconnue');
    } finally {
      setSubmitting(false);
    }
  }

  const needsTrimmed = form.needs.trim();
  const needsValid = needsTrimmed.length >= 6;
  const canSubmit = needsValid && !!form.subject && !submitting;

  return (
    <form className="contact-form" onSubmit={handleSubmit} aria-label="Formulaire de contact">

      {status === 'success' && (
        <div className="cf-banner cf-banner--success">
          Message envoye ! Nous vous repondrons sous 24h.
        </div>
      )}
      {status === 'error' && (
        <div className="cf-banner cf-banner--error">
          Echec de l'envoi : {errorMsg}
        </div>
      )}

      <div className="row">
        <label>
          Nom
          <input name="name" value={form.name} onChange={handleChange} placeholder="Votre nom" required />
        </label>
        <label>
          Societe
          <input name="company" value={form.company} onChange={handleChange} placeholder="Votre societe" />
        </label>
      </div>

      <div className="row">
        <label>
          Email
          <input name="email" type="email" value={form.email} onChange={handleChange} placeholder="adresse@exemple.com" required />
        </label>
        <label>
          Telephone
          <input name="phone" value={form.phone} onChange={handleChange} placeholder="+225 00 00 00 00" />
        </label>
      </div>

      <label className="full">
        Objet de votre demande *
        <select name="subject" value={form.subject} onChange={handleChange} className="cf-select" required>
          <option value="">-- Selectionnez un sujet --</option>
          {SUBJECTS.map(s => (
            <option key={s} value={s}>{s}</option>
          ))}
        </select>
        {!form.subject && status === null && form.needs.length > 0 && (
          <span className="cf-hint">Veuillez selectionner un sujet.</span>
        )}
      </label>

      <label className="full">
        Message *
        <textarea
          name="needs"
          value={form.needs}
          onChange={handleChange}
          placeholder="Decrivez brievement votre besoin ou votre projet"
          rows={6}
          required
          minLength={6}
          onInvalid={(e) => e.target.setCustomValidity('Merci de preciser votre besoin (minimum 6 caracteres).')}
          onInput={(e) => e.target.setCustomValidity('')}
        />
        {!needsValid && form.needs.length > 0 && (
          <span className="cf-hint">Minimum 6 caracteres.</span>
        )}
      </label>

      <div className="actions">
        <button type="submit" className="btn-primary" disabled={!canSubmit}>
          {submitting ? 'Envoi en cours...' : 'Envoyer la demande'}
        </button>
      </div>
    </form>
  );
}
